import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import {
  setIsOpenWidget,
} from "../../store/slice/Activity.slice";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { setWebshopLoading } from "../../store/slice/Webshop.slice";
import WidgetComponent from "./WidgetComponent";
import useActivityWidget from "../../hooks/useActivityWidget";
dayjs?.extend(customParseFormat); // Extend for custom date format parsing


let loadSettings = null;
let widgetIdSettings = null;
const ActivityWidget = ({
  floating,
}) => {
  const{
    widgetConfig,
    buttonText,
    isOpenWidget,
    openWidget, 
    langLoading, 
    widgetLoading,
    setOpenWidget,
    dispatch,
    theme,
    send,
    getWidgetPositionStyle
  }=useActivityWidget()

  if (widgetLoading && langLoading)
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={widgetLoading}
        onClick={() => dispatch(setWebshopLoading(false))}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );

  if (!widgetConfig?.settings?.floatButtonActive || floating === "relative") {
    return (
      send("100vh", "100%", "", "0px", "0px", "", widgetConfig?.settings?.floatButtonActive),
      (<WidgetComponent  handleClose={()=>setOpenWidget(!openWidget)}/>)
    );
  }
  // Widget
  return (
    send(
      "100px",
      "150px",
      "",
      "0px",
      "0px",
      "",
      widgetConfig?.settings?.floatButtonActive
    ),
    (
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "",
          position: "relative",
        }}
      >
             {buttonText?.trim() != "" && !openWidget && (
          <Button
            sx={{
              position: "absolute",
              ...getWidgetPositionStyle(
                widgetConfig?.settings?.positionButton,
                true
              ),
              backgroundColor: theme?.widgetButton?.bgColor,
              color: theme?.widgetButton?.textColor,
              margin: "10px",
              zIndex: "99999",
            }}
            onClick={() => {
              setOpenWidget(!openWidget);
              dispatch(setIsOpenWidget(!isOpenWidget));
            }}
          >
            {buttonText}
          </Button>
        )}


        {openWidget &&
          (send("100vh", "120px", "0px", "0px", "0px", "", widgetConfig?.settings?.floatButtonActive),
          (<WidgetComponent  handleClose={()=>setOpenWidget(!openWidget)}/>))}
      </Box>
    )
  );
};
export default ActivityWidget;
